import * as classic from "../../designs/classic";
import * as element from "../../designs/element";
import * as element_internal from "../../designs/element-internal";
import * as element_dense from "../../designs/element-dense";
import * as element_compact from "../../designs/element-compact";
import * as brage_external from "../brage_external/designs/brage";

export {
	classic,
	element_internal,
	element_dense,
	element_compact,
	brage_external
};

export default element;
